import React from "react";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {
  Add,
  AddPhotoAlternate,
  ArrowBack,
  ArrowDownward,
  ArrowUpward,
  Assessment,
  AssignmentReturned,
  Ballot,
  Check,
  Close,
  CloudUpload,
  Collections,
  Delete,
  Download,
  Draw,
  Edit,
  Folder,
  GppGood,
  Image,
  ImageNotSupported,
  Inventory2,
  LocalShipping,
  LocationOn,
  NavigateBefore,
  NavigateNext,
  People,
  Remove,
  Restore,
  Send,
  Settings,
  TextSnippet,
  UploadFile,
  Password,
} from "@mui/icons-material";

const ICON_MAP = {
  Add,
  AddPhotoAlternate,
  ArrowBack,
  ArrowDownward,
  ArrowUpward,
  Assessment,
  AssignmentReturned,
  Ballot,
  Check,
  Close,
  CloudUpload,
  Collections,
  Delete,
  Download,
  Draw,
  Edit,
  Folder,
  GppGood,
  Image,
  ImageNotSupported,
  Inventory2,
  LocalShipping,
  LocationOn,
  NavigateBefore,
  NavigateNext,
  People,
  Password,
  Remove,
  Restore,
  Send,
  Settings,
  TextSnippet,
  UploadFile,
};

export default function IconsAvaliable({
  iconName,
  onClick,
  fontSize = "small",
  style = {},
  sx,
  to,
  tooltip,
}) {
  const IconComponent = ICON_MAP[iconName] || Folder;
  const buttonSx = sx ?? style;

  const icon = <IconComponent fontSize={fontSize} sx={{ color: "inherit" }} />;

  if (to) {
    return (
      <Tooltip title={tooltip}>
        <IconButton component={Link} to={to} onClick={onClick} sx={buttonSx}>
          {icon}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={onClick} sx={buttonSx}>
        {icon}
      </IconButton>
    </Tooltip>
  );
}
